import React, { useRef } from "react";
import Ueditor from "@/components/Ueditor";

// ==================== 类型定义 ====================
interface RichTextEditorProps {
  value?: string;
  onChange?: (content: string) => void;
  config?: any;
  placeholder?: string;
  style?: React.CSSProperties;
  className?: string;
  [propName: string]: any;
}

// ==================== 常量配置 ====================
const DEFAULT_CONFIG = {
  initialFrameWidth: "100%",
  initialFrameHeight: 350,
  autoHeightEnabled: false,
  // 邮件模板工具栏配置
  toolbars: [
    [
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "|",
      "forecolor",
      "backcolor",
      "|",
      "justifyleft",
      "justifycenter",
      "justifyright",
      "justifyjustify",
      "|",
      "insertorderedlist",
      "insertunorderedlist",
      "|",
      "link",
      "unlink",
      "|",
      "undo",
      "redo",
    ],
  ],
};

// ==================== 主组件 ====================
const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value = "",
  onChange,
  config,
  placeholder,
  style,
  className,
  ...rest
}) => {
  const editorRef = useRef<any>(null);

  // 处理编辑器内容变化
  const handleEditorChange = () => {
    if (
      editorRef.current &&
      typeof editorRef.current.getContent === "function"
    ) {
      try {
        const content = editorRef.current.getContent();
        onChange?.(content);
      } catch (error) {
        console.error("获取编辑器内容失败:", error);
      }
    }
  };

  // 获取编辑器实例
  const getEditor = (ue: any) => {
    if (!ue) {
      console.warn("编辑器实例为空");
      return;
    }

    editorRef.current = ue;

    try {
      // 监听内容变化事件
      if (typeof ue.addListener === "function") {
        ue.addListener("contentChange", () => {
          handleEditorChange();
        });
      }

      // 初始化时设置内容
      if (value && typeof ue.ready === "function") {
        ue.ready(() => {
          setTimeout(() => {
            if (typeof ue.setContent === "function") {
              ue.setContent(value);
            }
          }, 100);
        });
      }
    } catch (error) {
      console.error("编辑器初始化失败:", error);
    }
  };

  const mergedConfig = {
    ...DEFAULT_CONFIG,
    ...config,
  };

  return (
    <div
      className={className}
      style={{
        border: "1px solid #d9d9d9",
        borderRadius: "2px",
        ...style,
      }}
      {...rest}
    >
      <Ueditor
        config={mergedConfig}
        value={value}
        getEditor={getEditor}
        style={{ width: "100%", minHeight: mergedConfig.initialFrameHeight }}
      />
    </div>
  );
};

export default RichTextEditor;
